var render, staticRenderFns
import script from "./InjectFunctional.vue?vue&type=script&lang=js&"
export * from "./InjectFunctional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports